import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Pages.css';

const STATUSES = ['all', 'pending', 'awaiting_payment', 'confirmed', 'completed', 'rejected'];

function AdminBookings({ apiUrl, token }) {
  const [bookings, setBookings] = useState([]);
  const [filter, setFilter] = useState('all');
  const [error, setError] = useState('');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchBookings = () => {
    const url = filter === 'all' ? `${apiUrl}/admin/bookings` : `${apiUrl}/admin/bookings?status=${filter}`;
    axios.get(url, { headers }).then((res) => setBookings(res.data)).catch((err) => setError(err.response?.data?.error || 'Failed to load bookings'));
  };

  useEffect(fetchBookings, [apiUrl, token, filter]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>All Bookings</h1>
      </div>
      {error && <div className="error-message">{error}</div>}

      <div className="tabs">
        {STATUSES.map((s) => (
          <button key={s} className={`tab-btn ${filter === s ? 'active' : ''}`} onClick={() => setFilter(s)}>
            {s === 'all' ? 'All' : s.replace('_', ' ')}
          </button>
        ))}
      </div>

      <div className="list-container table-wrap">
        <table className="table">
          <thead>
            <tr><th>Service</th><th>Client</th><th>Practitioner</th><th>Date</th><th>Status</th><th>Invoice</th><th></th></tr>
          </thead>
          <tbody>
            {bookings.map((b) => (
              <tr key={b.id}>
                <td>{b.service_name}</td>
                <td>{b.client_name}</td>
                <td>{b.practitioner_name}</td>
                <td>{new Date(b.booking_date).toLocaleDateString()}</td>
                <td><span className={`badge badge-${b.status}`}>{b.status.replace('_', ' ')}</span></td>
                <td>{b.invoice_status ? <span className={`badge badge-${b.invoice_status}`}>{b.invoice_status}</span> : <span className="text-muted">—</span>}</td>
                <td><Link to={`/bookings/${b.id}`} className="btn btn-secondary btn-sm">View</Link></td>
              </tr>
            ))}
            {bookings.length === 0 && <tr><td colSpan="7" className="empty-state">No bookings found</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AdminBookings;
